import { createContext } from 'react';

interface DynamicEntitiesRegistrationContextValue {
  register: () => void;
}

export const DynamicEntitiesRegistrationContext = createContext<DynamicEntitiesRegistrationContextValue | null>(null);
